<template>
  <v-dialog v-model="dialogOpen" max-width="500">
    <v-card class="edit-dialog">
      <v-card-title class="edit-dialog__title">
        {{ isEditing ? "Edit Requirement" : "Add Requirement" }}
      </v-card-title>

      <v-card-text class="pt-6">
        <v-select
          ref="attributeSelect"
          v-model="formData.attribute_id"
          :items="attributes"
          item-title="name"
          item-value="id"
          label="Attribute"
          outlined
          class="mb-4"
        ></v-select>

        <v-textarea
          v-model="formData.text"
          label="Requirement Text"
          placeholder="Enter requirement text"
          outlined
          rows="3"
        ></v-textarea>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeModal">Cancel</v-btn>
        <v-btn color="primary" @click="saveRequirement" :loading="isSaving">
          <v-icon left>mdi-check</v-icon>
          {{ isEditing ? "Save" : "Create" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RequirementEditModal",

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    requirement: {
      type: Object,
      default: null,
    },
    attributes: {
      type: Array,
      default: () => [],
    },
    selectedProblem: {
      type: [String, Number],
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["close", "save", "delete"],

  data() {
    return {
      formData: {
        attribute_id: "",
        text: "",
      },
    };
  },

  computed: {
    isEditing() {
      return this.requirement !== null;
    },
    dialogOpen: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit("close", value);
        }
      },
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        if (this.isEditing) {
          this.formData.attribute_id = this.requirement.attribute_id;
          this.formData.text = this.requirement.text;
          if (!this.formData.attribute_id) {
            this.formData.attribute_id = this.attributes.find(
              (attr) => attr.name === this.requirement.attribute
            )?.id;
          }
        } else {
          this.formData.attribute_id = "";
          this.formData.text = "";
        }
        // Focus on attribute select for new requirements
        this.$nextTick(() => {
          if (this.$refs.attributeSelect && !this.isEditing) {
            this.$refs.attributeSelect.focus();
          }
        });
      }
    },
  },

  methods: {
    saveRequirement() {
      if (!this.formData.attribute_id || !this.formData.text.trim()) {
        return;
      }

      this.$emit("save", {
        id: this.isEditing ? this.requirement.id : undefined,
        attribute_id: this.formData.attribute_id,
        text: this.formData.text,
        problem_id: this.selectedProblem,
      });
    },

    closeModal() {
      this.$emit("close", false);
    },
  },
};
</script>

<style scoped>
.edit-dialog__title {
  color: var(--backgroundColor) !important;
  background-color: var(--primaryColor) !important;
}
</style>
